import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { WEATHER_API_KEY } from "../../../services/apiKeys";

import TemperatureMin from "../../../assets/icons/icon-arrow-down-blue.png";
import TemperatureMax from "../../../assets/icons/icon-arrow-up-red.png";
import Cloud from "../../../assets/icons/icon-weather-rain-gray.png";
import Precipitation from "../../../assets/icons/icon-water-gray.png";
import Umity from "../../../assets/icons/icon-rain2-gray.png";
import Air from "../../../assets/icons/icon-air-gray.png";
import IconSearchNotFound from "../../../assets/icons/icons8-search-notfound.png";

import * as S from "./styles";
import { theme } from "../../../styles/theme";
import { TaglineM } from "../../../styles/stylesTypography";
import api from "../../../services/api";
import { apiprevmet3 } from "../../../services/inmet_api";
import SelectV2MultiHeaderFarm from "../../select/select_v2_muilti_header_farm";

const CalendaryWeatherForecast = ({
  updateCoordinates,
  codIBGE: externalCodIBGE,
  location: externalLocation,
  showFarmSelector = true,
}) => {
  const weekDays = ["D", "S", "T", "Q", "Q", "S", "S"];

  const getBrazilDate = () => {
    const now = new Date();
    const brazilTime = new Date(now.toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }));
    return brazilTime;
  };

  const today = getBrazilDate();
  const todayWithoutTime = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  const getNext7Days = () => {
    return Array.from({ length: 7 }, (_, index) => {
      const brazilToday = getBrazilDate();
      const date = new Date(brazilToday.getFullYear(), brazilToday.getMonth(), brazilToday.getDate() + index);
      return {
        dayOfWeek: weekDays[date.getDay()],
        day: date.getDate(),
        fullDate: date,
      };
    });
  };

  const days = getNext7Days();
  const [selectedDate, setSelectedDate] = useState(todayWithoutTime);
  const [weatherData, setWeatherData] = useState(null);
  const [location, setLocation] = useState(externalLocation || "");
  const [nomeFarm, setNomeFarm] = useState("");
  const [fazendas, setFazendas] = useState([]);
  const [fazendaEndereco, setFazendaEndereco] = useState("");
  const [inmetData, setInmetData] = useState([]);
  const [ibge, setIbge] = useState(externalCodIBGE || "");

  const [coordenadas, setCoordenadas] = useState({
    latitude: "",
    longitude: "",
  });

  const [farmId, setFarmId] = useState("");

  const [loadingSelectMultHeader, setLoadingSelectMultHeader] = useState(false);

  const getFazendas = async () => {
    try {
      setLoadingSelectMultHeader(true);
      const response = await api.get("/fazendas?limit=30&offset=0");
      const fazendasData = response.data.data.fazendas;
      setFazendas(fazendasData);
      if (fazendasData.length > 0) {
        setFarmId(fazendasData[0].id);
        setLocation(fazendasData[0].cidade);
        setNomeFarm(fazendasData[0].nome);
        getFazendaDetails(fazendasData[0].id);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingSelectMultHeader(false);
    }
  };

  // Função para converter coordenadas DMS para decimal
  const convertDMSToDecimal = (dmsString) => {
    if (!dmsString || typeof dmsString !== 'string') {
      return null;
    }

    const dmsRegex = /(\d+)°(\d+)'([\d.]+)"([NSEW])/;
    const match = dmsString.match(dmsRegex);

    if (!match) {
      return null;
    }

    const degrees = parseInt(match[1]);
    const minutes = parseInt(match[2]);
    const seconds = parseFloat(match[3]);
    const direction = match[4];

    let decimal = degrees + (minutes / 60) + (seconds / 3600);

    if (direction === 'S' || direction === 'W') {
      decimal = -decimal;
    }

    return decimal;
  };

  const getFazendaDetails = async (id) => {
    try {
      const response = await api.get(`/fazendas/${id}`);
      if (response) {
        const fazenda = response.data.data;
        setFazendaEndereco(`${fazenda.endereco}, ${fazenda.bairro}, ${fazenda.numero}, ${fazenda.cidade}-${fazenda.estado}`)

        let latitude = fazenda.latitude;
        let longitude = fazenda.longitude;

        if (typeof latitude === 'string' && latitude.includes('°')) {
          latitude = convertDMSToDecimal(latitude);
        }
        if (typeof longitude === 'string' && longitude.includes('°')) {
          longitude = convertDMSToDecimal(longitude);
        }

        setCoordenadas({
          latitude: latitude,
          longitude: longitude,
        })
        setIbge(fazenda.cod_ibge);
        getInmetData(fazenda.cod_ibge);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadGoogleMapsAPI = () => {
    return new Promise((resolve, reject) => {
      // Verifica se a API já está carregada
      if (window.google && window.google.maps && window.google.maps.Geocoder) {
        resolve();
        return;
      }

      // Remove scripts existentes para evitar conflitos
      const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Define callback global para inicialização
      window.initGoogleMaps = () => {
        if (window.google && window.google.maps && window.google.maps.Geocoder) {
          // Limpa o callback global após o uso
          delete window.initGoogleMaps;
          resolve();
        } else {
          delete window.initGoogleMaps;
          reject(new Error('Google Maps API não inicializou corretamente'));
        }
      };

      // Cria e adiciona o script da API com loading=async
      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAn3UaVotrho9E6f_BWtW4wDshxnEmM8LI&libraries=places,drawing&loading=async&callback=initGoogleMaps';
      script.async = true;
      script.defer = true;

      script.onerror = () => {
        reject(new Error('Erro ao carregar Google Maps API'));
      };

      // Timeout de segurança
      setTimeout(() => {
        if (window.initGoogleMaps) {
          delete window.initGoogleMaps;
        }
        reject(new Error('Timeout ao carregar Google Maps API'));
      }, 15000);

      document.head.appendChild(script);
    });
  };

  const geocodeWithGoogleMaps = async (endereco) => {
    try {
      await loadGoogleMapsAPI();

      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: endereco }, (results, status) => {
          if (status === 'OK' && results[0]) {

            const location = results[0].geometry.location;

            const lat = location.lat();
            const lng = location.lng();

            resolve({ lat, lng });
          } else {
            reject(new Error(`Geocoding falhou: ${status}`));
          }
        });
      });
    } catch (error) {
      console.error('Erro ao carregar/usar Google Maps:', error);
      throw error;
    }
  };

  const geocodeWithAlternativeAPI = async (endereco) => {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(endereco)}&limit=1`);
      const data = await response.json();

      if (data && data.length > 0) {
        const lat = parseFloat(data[0].lat);
        const lng = parseFloat(data[0].lon);

        return { lat, lng };
      } else {
        return false;
      }
    } catch (error) {
      console.error('Erro na geocodificação alternativa:', error);
      return false;
    }
  };

  useEffect(() => {
    if (!showFarmSelector || !fazendaEndereco) return;

    const geocodeAddress = async () => {
      if (
        (coordenadas.latitude === '' || coordenadas.latitude === null) &&
        (coordenadas.longitude === '' || coordenadas.longitude === null)
      ) {
        try {
          const result = await geocodeWithGoogleMaps(fazendaEndereco);
          if (result) {
            setCoordenadas({
              latitude: result.lat,
              longitude: result.lng,
            })
          }
        } catch (error) {
          const result = await geocodeWithAlternativeAPI(fazendaEndereco);
          if (result) {
            setCoordenadas({
              latitude: result.lat,
              longitude: result.lng,
            })
          }
        }
      }
    };

    geocodeAddress();
  }, [coordenadas.latitude, coordenadas.longitude, fazendaEndereco, showFarmSelector]);

  const getInmetData = async (ibge) => {
    try {
      const response = await apiprevmet3.get(`/previsao/${ibge}`);
      if (response) {
        let prev = response.data;
        setInmetData(prev);
      }
    } catch (error) {
      console.log(error);

      // store.addNotification({
      //   title: "Erro!",
      //   message: `${error.response.data.error} Para visualizar a previsão do clima, tente novamente mais tarde.`,
      //   type: "danger",
      //   insert: "top",
      //   container: "top-right",
      //   animationIn: ["animated", "fadeIn"],
      //   animationOut: ["animated", "fadeOut"],
      //   dismiss: {
      //       duration: 4000,
      //       onScreen: true
      //   }
      // });
    }
  };

  useEffect(() => {
    if (showFarmSelector) {
      getFazendas();
    }
  }, [showFarmSelector]);

  useEffect(() => {
    if (!showFarmSelector) {
      setLocation(externalLocation || "");
      setIbge(externalCodIBGE || "");
      if (externalCodIBGE) {
        getInmetData(externalCodIBGE);
      }
    }
  }, [externalCodIBGE, externalLocation, showFarmSelector]);

  useEffect(() => {
    if (typeof updateCoordinates === 'function') {
      updateCoordinates(coordenadas);
    }
  }, [coordenadas, updateCoordinates]);

  useEffect(() => {
    if (location) {
      const fetchWeather = async () => {
        try {
          const response = await axios.get(
            `https://api.openweathermap.org/data/2.5/forecast?q=${location}&units=metric&lang=pt&appid=${WEATHER_API_KEY}`
          );

          setWeatherData(response.data);
        } catch (error) {
          console.error("Erro ao buscar dados do clima:", error);
        }
      };

      fetchWeather();
    }
  }, [location]);

  const handleDayClick = (day) => {
    setSelectedDate(day.fullDate);
  };

  const getWeatherForSelectedDay = () => {
    if (!weatherData || !inmetData) return null;

    // Formatar data usando fuso horário de Brasília para consistência
    const selectedDateStr = selectedDate
      .toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" })
      .padStart(10, "0");

    const inmetDayData = inmetData[ibge]?.[selectedDateStr];

    let tempMin = null;
    let tempMax = null;

    if (inmetDayData) {
      const periodKey = Object.keys(inmetDayData).find((key) =>
        ["manha", "tarde", "noite"].includes(key)
      );

      if (periodKey) {
        tempMin = inmetDayData[periodKey].temp_min;
        tempMax = inmetDayData[periodKey].temp_max;
      } else {
        tempMin = inmetDayData.temp_min;
        tempMax = inmetDayData.temp_max;
      }
    }

    const filteredData = weatherData.list.filter((item) => {
      const itemDate = new Date(item.dt * 1000);
      // Converter para fuso horário de Brasília para comparação consistente
      const itemDateBrazil = new Date(itemDate.toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }));
      return itemDateBrazil.getDate() === selectedDate.getDate() &&
        itemDateBrazil.getMonth() === selectedDate.getMonth() &&
        itemDateBrazil.getFullYear() === selectedDate.getFullYear();
    });

    if (filteredData.length === 0) return null;

    const dayWeather = filteredData[0];
    const openWeatherTempMin = dayWeather.main.temp_min;
    const openWeatherTempMax = dayWeather.main.temp_max;

    return {
      tempMin: tempMin ? tempMin.toString().slice(0, 2) : openWeatherTempMin ? openWeatherTempMin.toString().slice(0, 2) : "N/A",
      tempMax: tempMax ? tempMax.toString().slice(0, 2) : openWeatherTempMax ? openWeatherTempMax.toString().slice(0, 2) : "N/A",
      humidity: Math.round(dayWeather.main.humidity).toString().slice(0, 2),
      probabilityRain: Math.round(dayWeather.pop * 100).toString().slice(0, 2),
      precipitation:
        filteredData.reduce(
          (max, item) => (item.rain ? Math.max(max, item.rain["3h"] || 0) : max),
          0
        ) > 0
          ? Math.round(filteredData.reduce(
            (max, item) => (item.rain ? Math.max(max, item.rain["3h"] || 0) : max),
            0
          )).toString()
          : "0",
      windSpeed: Math.round(dayWeather.wind.speed * 3.6).toString().slice(0, 2),
    };
  };

  const formatCPFOrCNPJ = (value) => {
    if (!value) return "Sem CPF/CNPJ";

    const cleaned = value.replace(/\D/g, "");
    if (!cleaned) return "Documento inválido";

    return cleaned.length <= 11 ? formatCPF(value) : formatCNPJ(value);
  };

  const formatCPF = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length !== 11) return value;

    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const formatCNPJ = (value) => {
    if (!value) return "";
    const cleaned = value.replace(/\D/g, "");
    if (cleaned.length !== 14) return value;

    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  };

  const fazendasFormatadas = useMemo(() => fazendas.map((f) => ({
    value: f.id,
    label: `${f.nome}${
      f.agro_producers?.nome ? ` - ${f.agro_producers.nome}` : ""
    } - CPF/CNPJ: ${formatCPFOrCNPJ(f.agro_producers?.cpf_cnpj) || "Não informado"}`,
    produtor: f.agro_producers,
    documento: f.agro_producers?.cpf_cnpj,
    nomeFazenda: f.nome,
  })), [fazendas]);

  const [fazendaSelecionada, setFazendaSelecionada] = useState(null);

  useEffect(() => {
    try {
      if (farmId && fazendasFormatadas.length > 0) {
        const selecionada = fazendasFormatadas.find((f) => f.value === farmId);
        setFazendaSelecionada(selecionada || null);
      }
    } catch (error) {
      console.error("Erro ao buscar fazenda selecionada:", error);
    }
  }, [farmId, fazendasFormatadas]);

  const handleFarmChange = (selectedFarm) => {
    if (!selectedFarm || !selectedFarm.value) {
      setFazendaSelecionada(null);
      setLocation("");
      setNomeFarm("");
      return;
    }

    const fazendaCompleta = fazendasFormatadas.find(
      (f) => f.value === selectedFarm.value
    );

    setFazendaSelecionada(fazendaCompleta);
    setLocation(selectedFarm.cidade || fazendaCompleta?.cidade);
    setNomeFarm(fazendaCompleta?.nomeFazenda || selectedFarm.label);
    getFazendaDetails(selectedFarm.value);
  };

  const weather = getWeatherForSelectedDay();

  return (
    <S.Container className="calendary">
      {showFarmSelector && (
        <div style={{ width: "100%", height: "auto" }}>
          <SelectV2MultiHeaderFarm
            height='auto'
            marginBottom={"0px"}
            name='produtor'
            className="select"
            placeholder="Selecione a Propriedade"
            labelWithAsterisk={false}
            id='produtor'
            value={fazendaSelecionada ? fazendaSelecionada : ""}
            disabled={false}
            loading={loadingSelectMultHeader}
            erro={false}
            onChange={(value) => {
              handleFarmChange(value);
            }}
            options={fazendasFormatadas}
            selectUniqueOption={true}
            buttonAddNew={false}
            messageErro={""}
            isModal={true}
            isClearable={false}
            enableDropdownSearch={true}
            dropdownSearchPlaceholder="Buscar"
            formatFarmDisplay={true}
          />
        </div>
      )}

      <S.WeekContainer>
        {days.map((day) => {
          const isToday = day.fullDate.getTime() === todayWithoutTime.getTime();
          const isSelected =
            selectedDate && selectedDate.getTime() === day.fullDate.getTime();

          return (
            <S.DayWrapper key={day.day}>
              <S.WeekDay>{day.dayOfWeek}</S.WeekDay>
              <S.DayNumber
                isSelected={isSelected}
                isToday={isToday}
                onClick={() => handleDayClick(day)}
              >
                {day.day}
              </S.DayNumber>
            </S.DayWrapper>
          );
        })}
      </S.WeekContainer>

      {weather ? (
        <S.Preview>
          <S.Preview1 weather={weather}>
            <S.MinTemperature>
              <img src={TemperatureMin} alt="Ícone de temperatura mínima" />
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Mín: {weather.tempMin}ºC
              </TaglineM>
            </S.MinTemperature>

            <S.ProbabilityRain>
              <img src={Cloud} alt="Ícone de nuvem com chuva" />
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Prob. Chuva: {weather.probabilityRain}%
              </TaglineM>
            </S.ProbabilityRain>

            <S.Humidity>
              <img src={Umity} alt="Ícone de umidade" />
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Umidade: {weather.humidity}%
              </TaglineM>
            </S.Humidity>
          </S.Preview1>

          <S.Preview2>
            <S.MaxTemperature>
              <img src={TemperatureMax} alt="Ícone de temperatura máxima" />
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Máx: {weather.tempMax}ºC
              </TaglineM>
            </S.MaxTemperature>

            <S.PrecipitationRain>
              <img src={Precipitation} alt="Ícone de precipitação" />
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Precipitação: {weather.precipitation} mm
              </TaglineM>
            </S.PrecipitationRain>

            <S.Wind>
              <img src={Air} alt="Ícone de vento" />
              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Vento: {weather.windSpeed}km/h
              </TaglineM>
            </S.Wind>
          </S.Preview2>
        </S.Preview>
      ) : (
        <S.Preview>
          <S.Preview1 weather={weather}>
            <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

            <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>Sem dados disponíveis</TaglineM>
          </S.Preview1>
        </S.Preview>
      )}
    </S.Container>
  );
};

export default CalendaryWeatherForecast;